import type { EnabledMfrrProductionUnit } from 'api/mfrr/mfrr.types'
import type { CellCoordinate, TableCellAdapter } from 'ui/components/HourlyDataTable/HourlyDataTable.types'
import { CMBID_DIRECTIONS, getCmCellKey, getEnabledMfrrProductionUnitKey, parseCmCellKey } from './MfrrBidTable.helper'

export function makeMfrrBidTableAdapter(units: EnabledMfrrProductionUnit[], rowCount: number): TableCellAdapter {
  const editableColumns = CMBID_DIRECTIONS.flatMap((direction) =>
    units.flatMap((unit) => [
      { direction, unitKey: getEnabledMfrrProductionUnitKey(unit), field: 'volume' as const },
      { direction, unitKey: getEnabledMfrrProductionUnitKey(unit), field: 'price' as const },
    ])
  )

  return {
    columnCount: editableColumns.length,
    rowCount,
    getCoordinate(cellKey: string): CellCoordinate | null {
      const parsed = parseCmCellKey(cellKey)
      if (!parsed) {
        return null
      }

      const columnIndex = editableColumns.findIndex(
        (column) =>
          column.direction === parsed.direction && column.unitKey === parsed.unitKey && column.field === parsed.field
      )

      if (columnIndex < 0 || parsed.hourIndex < 0 || parsed.hourIndex >= rowCount) {
        return null
      }

      return { rowIndex: parsed.hourIndex, columnIndex }
    },
    getCellKey(coord: CellCoordinate): string | null {
      if (
        coord.rowIndex < 0 ||
        coord.rowIndex >= rowCount ||
        coord.columnIndex < 0 ||
        coord.columnIndex >= editableColumns.length
      ) {
        return null
      }

      const column = editableColumns[coord.columnIndex]
      return getCmCellKey(coord.rowIndex, column.direction, column.unitKey, column.field)
    },
  }
}
